export default "__VITE_ASSET__BWztw8bd__"